import { ReactNode, createContext, useContext } from 'react';

import { useCreateExpiredStockAdjustment } from './hook';

type CreateExpiredStockAdjustmentContextType = ReturnType<
    typeof useCreateExpiredStockAdjustment
>;

const CreateExpiredStockAdjustmentContext =
    createContext<CreateExpiredStockAdjustmentContextType | null>(null);

export const CreateExpiredStockAdjustmentProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const contextValue = useCreateExpiredStockAdjustment();

    return (
        <CreateExpiredStockAdjustmentContext.Provider value={contextValue}>
            {children}
        </CreateExpiredStockAdjustmentContext.Provider>
    );
};

export const useCreateExpiredStockAdjustmentContext = () => {
    const context = useContext(CreateExpiredStockAdjustmentContext);
    if (!context) {
        throw new Error(
            'useCreateExpiredStockAdjustmentContext must be used within a CreateExpiredStockAdjustmentProvider',
        );
    }
    return context;
};
